/**
 * @file ソートパラメーター追加
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname AddSearchParameters
 * @classdesc ソートパラメーター追加
 */
export default class AddSearchParameters {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--sort
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		const params = Common.getParam();
		let parameters = ''
		for(let key in params){
			if(key !== 'sort') {
				parameters += `&${key}=${params[key]}`;
			}
		}
		let href = $e.attr('href');
		href = href + parameters;
		$e.attr('href', href);
	};
};
